import validate from "/root/work/frontends/kakao_gino/node_modules/.pnpm/nuxt@3.17.3_@netlify+blobs@8.2.0_@parcel+watcher@2.4.1_@types+node@22.15.3_db0@0.3.2_en_ed930961eef1125bfe8bb6e6664142f2/node_modules/nuxt/dist/pages/runtime/validate.js";
import permission_45global from "/root/work/frontends/kakao_gino/middleware/permission.global.ts";
import manifest_45route_45rule from "/root/work/frontends/kakao_gino/node_modules/.pnpm/nuxt@3.17.3_@netlify+blobs@8.2.0_@parcel+watcher@2.4.1_@types+node@22.15.3_db0@0.3.2_en_ed930961eef1125bfe8bb6e6664142f2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  permission_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/root/work/frontends/kakao_gino/middleware/auth.ts")
}